/* ============================================================================
   Pin-first (Horizon) — v2026-09-02 (v3: varre todas as páginas da coleção)
   Fixa o produto do ad na 1ª posição da grelha da coleção, na cor do ad.
   Parâmetros no URL da coleção:
     ?first=<handle | URL completo /products/...>   (obrigatório)
     &variant=<id numérico>                          (opcional — cor/tamanho)
   v2 (29 ago): o theme.liquid marca <html class="pin-first-pending"> no <head>
   quando há ?first= e esconde a grelha (visibility:hidden, sem CLS) até o pin
   estar feito — a grelha aparece JÁ com o produto em 1º em vez de saltar.
   O JSON do produto (cor) pede-se logo ao arrancar e TODAS as páginas seguintes
   da paginação em paralelo, não em série. Teto absoluto REVEAL_MS: passe o que
   passar, a grelha mostra-se (com ou sem pin). Sem parâmetros = zero efeito.
   v3 (2 set): MAX_PAGE 5 -> 20. Com o teto a 5 e a coleção classic-t-shirts já
   com 8 páginas, qualquer produto da página 6+ falhava o pin em silêncio.
   Medido a 2 set: cada página custa 0,37-0,99 s e vão em paralelo, logo 7 fetches
   cabem à vontade nos 2,5 s do REVEAL_MS (não foi preciso mexer nesse teto).
   Limite conhecido: o produto tem de pertencer à coleção de aterragem;
   filtrar/ordenar refaz a grelha e desfaz o pin.
============================================================================ */
(() => {
  const REVEAL_MS = 2500;
  const MAX_PAGE = 20;   /* 2 set 2026: era 5 e a coleção tem 8 páginas — os produtos das
                           páginas 6+ nunca eram encontrados e o pin falhava em SILÊNCIO
                           (caso Lab Rats p.7 e Two Types p.6). 20 = guarda de sanidade
                           contra um data-last-page absurdo, não um limite de desenho:
                           varre-se sempre até à ÚLTIMA página da coleção. */
  const html = document.documentElement;
  const reveal = () => html.classList.remove('pin-first-pending');

  const qp = new URLSearchParams(location.search);
  let raw = (qp.get('first') || '').trim();
  if (!raw) { reveal(); return; }

  /* teto: nunca deixar a grelha escondida mais do que REVEAL_MS */
  const revealTimer = setTimeout(reveal, REVEAL_MS);

  let handle = '';
  let variantFromUrl = '';
  if (raw.startsWith('http')) {
    try {
      const u = new URL(raw);
      const segs = u.pathname.split('/').filter(Boolean);
      if (segs[0] === 'products' && segs[1]) handle = segs[1];
      variantFromUrl = u.searchParams.get('variant') || '';
    } catch (_) {}
  } else {
    handle = raw.split('/').filter(Boolean).pop() || '';
  }
  if (!handle) { clearTimeout(revealTimer); reveal(); return; }

  const vParam = qp.get('variant') || variantFromUrl;
  const variantId = /^\d+$/.test(vParam) ? vParam : '';

  /* pedir já o JSON do produto (imagem da cor) — corre em paralelo com o parse */
  const productPromise = variantId
    ? fetch(`/products/${encodeURIComponent(handle)}.js`).then((r) => r.json()).catch(() => null)
    : Promise.resolve(null);

  const ready = (fn) =>
    document.readyState === 'loading'
      ? document.addEventListener('DOMContentLoaded', fn, { once: true })
      : fn();

  const cardHandle = (li) => {
    const a = li.querySelector('a[href*="/products/"]');
    if (!a) return '';
    try {
      const path = new URL(a.getAttribute('href'), location.origin).pathname;
      const segs = path.split('/').filter(Boolean);
      const i = segs.indexOf('products');
      return i >= 0 ? (segs[i + 1] || '') : '';
    } catch (_) {
      return '';
    }
  };

  const findCard = (root) => {
    for (const li of root.querySelectorAll('li.product-grid__item')) {
      if (cardHandle(li) === handle) return li;
    }
    return null;
  };

  const fetchCardFromPage = async (p) => {
    try {
      const u = new URL(location.href); /* mantém preview_theme_id no draft */
      u.searchParams.set('page', String(p));
      const r = await fetch(u.toString(), { credentials: 'same-origin' });
      if (!r.ok) return null;
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const remoteGrid = doc.querySelector('ul.product-grid');
      const hit = remoteGrid && findCard(remoteGrid);
      return hit ? document.importNode(hit, true) : null;
    } catch (_) {
      return null;
    }
  };

  const applyVariant = (card, prod) => {
    if (!prod || !variantId) return;
    const varObj = (prod.variants || []).find((x) => String(x.id) === variantId);
    const imgSrc = varObj && varObj.featured_image && varObj.featured_image.src;
    if (imgSrc) {
      card.querySelectorAll('img').forEach((el) => {
        el.src = imgSrc;
        el.removeAttribute('srcset');
        el.loading = 'eager';
        const pic = el.closest('picture');
        if (pic) pic.querySelectorAll('source').forEach((s) => s.remove());
      });
    }
    card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
      try {
        const u = new URL(a.getAttribute('href'), location.origin);
        u.searchParams.set('variant', variantId);
        a.setAttribute('href', u.pathname + u.search);
      } catch (_) {}
    });
  };

  ready(async () => {
    try {
      const grid = document.querySelector('ul.product-grid');
      if (!grid) return;

      let card = findCard(grid);

      if (!card) {
        /* paginação: páginas 2..MAX_PAGE em PARALELO; fica o hit de página mais baixa */
        const lastPage = parseInt(grid.getAttribute('data-last-page') || '1', 10);
        const pages = [];
        for (let p = 2; p <= Math.min(lastPage, MAX_PAGE); p++) pages.push(fetchCardFromPage(p));
        const hits = await Promise.all(pages);
        card = hits.find(Boolean) || null;
      }
      if (!card) return;

      /* imagem da cor: se o JSON já chegou (quase sempre), aplica antes de revelar */
      applyVariant(card, await productPromise);
      grid.prepend(card);
    } catch (_) {
    } finally {
      clearTimeout(revealTimer);
      reveal();
    }
  });
})();
